// Mock customers data for CustomerCRM
const customersData = [
  {
    id: 1,
    name: 'Alice Smith',
    status: 'Active',
    signUpDate: '2024-01-10',
    lastActiveDate: '2025-06-01',
    lifetimeValue: 1200,
    purchaseHistory: [
      { date: '2024-01-15', amount: 100 },
      { date: '2024-03-10', amount: 200 },
      { date: '2024-06-20', amount: 300 },
      { date: '2025-01-05', amount: 600 }
    ],
    interests: ['Skincare', 'Eco', 'Vegan'],
    segments: ['Loyal', 'Eco Friendly'],
    recommendedCommunications: [
      { type: 'Email', date: '2025-06-05', message: 'New eco product launch' },
      { type: 'SMS', date: '2025-06-10', message: 'Loyalty reward reminder' }
    ]
  },
  {
    id: 2,
    name: 'Bob Lee',
    status: 'Inactive',
    signUpDate: '2024-02-20',
    lastActiveDate: '2024-12-15',
    lifetimeValue: 400,
    purchaseHistory: [
      { date: '2024-02-25', amount: 200 },
      { date: '2024-05-10', amount: 200 }
    ],
    interests: ['Haircare', 'Men'],
    segments: ['Returning'],
    recommendedCommunications: [
      { type: 'Push', date: '2025-06-07', message: 'We miss you! Come back for a discount.' }
    ]
  },
  {
    id: 3,
    name: 'Carla Gomez',
    status: 'Active',
    signUpDate: '2024-05-05',
    lastActiveDate: '2025-06-06',
    lifetimeValue: 900,
    purchaseHistory: [
      { date: '2024-05-10', amount: 300 },
      { date: '2024-08-15', amount: 300 },
      { date: '2025-03-20', amount: 300 }
    ],
    interests: ['Makeup', 'Vegan'],
    segments: ['Returning', 'Vegan'],
    recommendedCommunications: [
      { type: 'Email', date: '2025-06-08', message: 'Vegan makeup tips' }
    ]
  },
  {
    id: 4,
    name: 'David Kim',
    status: 'Active',
    signUpDate: '2024-09-12',
    lastActiveDate: '2025-05-30',
    lifetimeValue: 600,
    purchaseHistory: [
      { date: '2024-09-15', amount: 200 },
      { date: '2025-01-10', amount: 400 }
    ],
    interests: ['Haircare', 'Eco'],
    segments: ['New'],
    recommendedCommunications: [
      { type: 'SMS', date: '2025-06-09', message: 'Eco haircare sale' }
    ]
  },
  {
    id: 5,
    name: 'Eva Müller',
    status: 'Active',
    signUpDate: '2025-03-01',
    lastActiveDate: '2025-06-06',
    lifetimeValue: 300,
    purchaseHistory: [
      { date: '2025-03-05', amount: 150 },
      { date: '2025-05-20', amount: 150 }
    ],
    interests: ['Skincare'],
    segments: ['New'],
    recommendedCommunications: [
      { type: 'Email', date: '2025-06-10', message: 'Welcome to Suspire! Skincare tips inside.' }
    ]
  }
];

export default customersData;
